module.exports = __webpack_public_path__ + "static/media/banner-infant.a895739a.jpg";